export const truncateWorkExperienceDesc = (
  text: string,
  maxLength: number,
): string => {
  if (text?.length <= maxLength) return text;
  const truncated = text?.slice(0, maxLength);
  const lastSpaceIndex = truncated?.lastIndexOf(" ");
  if (lastSpaceIndex === -1) return truncated + "...";
  return truncated?.slice(0, lastSpaceIndex) + "...";
};

export const trunkAboutDesc = (text: string, maxLength: number): string => {
  if (text?.length <= maxLength) return text;
  const truncated = text?.slice(0, maxLength);
  const lastSpaceIndex = truncated?.lastIndexOf(" ");
  if (lastSpaceIndex === -1) return truncated + "...";
  return truncated?.slice(0, lastSpaceIndex) + "...";
};

export const trunkPropertyDesc = (text: string, maxLength: number): string => {
  if (text?.length <= maxLength) return text;
  const truncated = text?.slice(0, maxLength);
  const lastSpaceIndex = truncated?.lastIndexOf(" ");
  if (lastSpaceIndex === -1) return truncated + "...";
  return truncated?.slice(0, lastSpaceIndex) + "...";
};

export const replaceSpecialChars = (text: string): string => {
  return text.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "-");
};

export const getMonthName = (monthIndex: number, locale: string): string => {
  const date = new Date();
  date.setMonth(monthIndex);
  return date.toLocaleString(locale, { month: "long" });
};

export const playNotificationSound = () => {
  const audio = new Audio("/sounds/notify.mp3");
  audio.play();
};

export function to12h(time: string, locale: string): string {
  const [h, m] = time.split(":").map(Number);
  const period =
    h >= 12 ? (locale === "ar" ? "م" : "PM") : locale === "ar" ? "ص" : "AM";
  const hour = h % 12 === 0 ? 12 : h % 12;
  return `${hour}:${m.toString().padStart(2, "0")} ${period}`;
}

export function getUpcomingDates(
  dayName: string,
  count = 8,
  DAY_INDEX: Record<string, number>,
): Date[] {
  const target = DAY_INDEX[dayName];
  const dates: Date[] = [];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const cur = new Date(today);
  cur.setDate(cur.getDate() + 1);
  while (dates.length < count) {
    if (cur.getDay() === target) dates.push(new Date(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return dates;
}

export function generateTimeSlots(from: string, to: string) {
  const slots: string[] = [];
  const [fh, fm] = from.split(":").map(Number);
  const [th, tm] = to.split(":").map(Number);
  let cur = fh * 60 + fm;
  const end = th * 60 + tm;
  while (cur < end) {
    const h = Math.floor(cur / 60)
      .toString()
      .padStart(2, "0");
    const m = (cur % 60).toString().padStart(2, "0");
    slots.push(`${h}:${m}`);
    cur += 30;
  }
  return slots;
}
